import type { CoachmarkPersistedFlow } from './types'

const STORAGE_PREFIX = 'credem.ftue.'

function storageKey(flowId: string): string {
  return `${STORAGE_PREFIX}${flowId}`
}

export function readFlowState(flowId: string): CoachmarkPersistedFlow | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(storageKey(flowId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<CoachmarkPersistedFlow>
    if (!parsed || typeof parsed !== 'object') return null
    if (
      parsed.state !== 'pending' &&
      parsed.state !== 'active' &&
      parsed.state !== 'completed' &&
      parsed.state !== 'dismissed'
    ) {
      return null
    }
    if (typeof parsed.version !== 'number') return null
    return {
      state: parsed.state,
      step: typeof parsed.step === 'string' ? parsed.step : null,
      version: parsed.version,
    }
  } catch {
    return null
  }
}

export function writeFlowState(flowId: string, value: CoachmarkPersistedFlow): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(storageKey(flowId), JSON.stringify(value))
  } catch {
    // localStorage may be unavailable (private mode, quota); fail silently.
  }
}

export function clearFlowState(flowId: string): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(storageKey(flowId))
  } catch {
    // ignore
  }
}
